var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{staticClass:"btn btn-secondary px-4 text-uppercase text-white circular-black btn-event-trigger",attrs:{"id":"purchase-now","href":"https://loopcommunity.com/shop/tracks-made-easy-workshop---replay-30272"}},[_vm._v(" "+_vm._s(_vm.$t("nav.LIT_PurchaseNow"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }